import React, { useCallback, useContext, useEffect, useState } from 'react'
import { IOSSwitch, ManagerDashboardStyles } from './Style'
import { constants as c, constants, useDashboardCards } from './hooks'
import { AutoComplete, Button, IconButtonGroup } from 'components/Form'
import { Img, LightButton, LightButton2 } from 'styles/GlobalStyle'
import { Go2, Countries, LineStats } from 'assets'
import { CircularProgress, FormControlLabel, SvgIcon, Switch } from '@mui/material'
import './style.css'
import { BarChart, dashboardHooks, DoughnutChart, PisaBarChart } from '.'
import { assessmentsHooks } from 'pages/School/Assessments'
import { DashboardContext } from './DashboardContext'
import AssessmentFiltersHeader from 'pages/School/Assessments/AssessmentFiltersHeader'
import { RatingList, RatingSquareList } from 'components/Rating'
import { ratingColors4, ratingListLabel } from 'keys/rating'
import { KeyboardBackspace } from '@mui/icons-material'
import { secondary } from 'styles/theme'
import { thirdly } from 'styles/theme'
import { reverse } from 'lodash'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'

const DashboardPage = () => {
    const { assessmentFilters, setAssessmentFilters, currentDoughnutChart, setCurrentDoughnutChart } = useContext(DashboardContext)

    const { title } = dashboardHooks.constants
    const cards = dashboardHooks.useDashboardCards()
    const doughnutChartList = dashboardHooks.useDoughnutChartList()
    const headerItems = assessmentsHooks.useHeaderItems()

    const navigate = useNavigate()

    const [showGoResult, setShowGoResult] = useState(true)

    const handleChangeDoughnutChart = useCallback((index) => {
        setCurrentDoughnutChart(index)
        doughnutChartList[index].refetch()
    }, [])

    const refetchDoughnut = useCallback(() => {
        doughnutChartList[currentDoughnutChart].refetch()
    }, [currentDoughnutChart])

    const goAssessmentsPage = useCallback(() => {
        navigate(app.assessments, { state: { view: "chart" } });
    }, [])

    useEffect(() => {
        doughnutChartList[0].refetch()
    }, [])

    const barChartlabels = [{ label: "בלי GoRead", color: "#D9D9D9" }, { label: "סוף שנה", color: secondary }, { label: "אמצע שנה", color: thirdly }]

    return (
        <ManagerDashboardStyles>
            <div className='dashboard'>
                <div>
                    <div className="card-header">
                        <div className='dashboard-cartoon-card'>
                            <div className='dashboard-title'>
                                {title}
                            </div>
                            <div className='dashboard-cartoon'>
                                <Img src={Go2} />
                            </div>
                        </div>
                        <div className='wrap-cards'>
                            <div className='stats-cards'>
                                <div className='card circle-stats'>
                                    <div className='chart-header'>
                                        <div className='chart-title'>
                                            {"נתונים של כל התלמידים שלך"}
                                        </div>
                                        <AssessmentFiltersHeader
                                            hideSearchBtn
                                            loading={doughnutChartList[currentDoughnutChart].loading}
                                            // disabledSearch={!assessmentFilters.assessment_def}
                                            headerItems={[
                                                headerItems.year
                                            ]}
                                            refetchData={refetchDoughnut}
                                            showLoading={true}
                                            assessmentFilters={assessmentFilters}
                                            setAssessmentFilters={setAssessmentFilters}
                                        />
                                    </div>
                                    <div className='doughnut-and-list'>
                                        <div className='circle-stats-list'>
                                            {doughnutChartList.map((stat, index) =>
                                                <LightButton2
                                                    size="small"
                                                    label={stat.label}
                                                    action={(e) => {
                                                        handleChangeDoughnutChart(index)
                                                    }}
                                                    key={index}
                                                    selected={currentDoughnutChart == index}
                                                />
                                            )}
                                        </div>
                                        <div className='doughnut-and-select'>
                                            <div className='circle-stats-img'>
                                                <DoughnutChart loading={doughnutChartList[currentDoughnutChart].loading} data={doughnutChartList[currentDoughnutChart].data?.percent} />
                                            </div>
                                            <div className='level-list'>
                                                <RatingSquareList colors={ratingColors4} labels={ratingListLabel} />
                                            </div>
                                        </div>
                                        <div className='all-data-btn'>
                                            <LightButton label={"לכל הנתונים"} direction="rtl" icon={<KeyboardBackspace fontSize='small' />} size="small" action={goAssessmentsPage} />
                                        </div>
                                    </div>
                                </div>
                                <div className='card line-stats'>
                                    <div className='chart-header'>
                                        <div className='chart-title'>
                                            {"התקדמות"}
                                            <div className='chart-sub-title'>
                                                {"(beta בהרצה. הנתונים להמחשה בלבד)"}
                                            </div>
                                        </div>
                                        <div>
                                            <AutoComplete minWidth={170} width={170} input={{}} options={[]} disabled={true} placeholder="ביחס לסמסטר קודם" />
                                        </div>
                                    </div>
                                    <div className='bar-chart-details'>
                                        <FormControlLabel
                                            control={<IOSSwitch sx={{ m: 1 }} defaultChecked onChange={() => setShowGoResult(!showGoResult)} />}
                                        />
                                        {barChartlabels.map((item) =>
                                            <div className='bar-chart-detail'>
                                                <div className='dot' style={{ background: item.color }} />
                                                <div>{item.label}</div>
                                            </div>
                                        )}
                                    </div>
                                    <div className='bar-chart'>
                                        <BarChart showGoResult={showGoResult} />
                                    </div>
                                </div>
                            </div>
                            <div className='wrap-pisabar-stats'>
                                <div className='card pisabar-stats'>
                                    <div className='chart-header'>
                                        <div className='chart-title'>
                                            {"הדמיה לנתונים של PISA"}
                                            <div className='chart-sub-title'>
                                                {"(beta בהרצה. הנתונים להמחשה בלבד)"}
                                            </div>
                                        </div>
                                    </div>
                                    <PisaBarChart />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className='card-content'>
                    {cards.map((card) => {
                        const { label, button, loading, icon } = card
                        return (
                            <div className='dashboard-card'>
                                {loading ?
                                    <CircularProgress color="gray" size={30} /> :
                                    <div className='card-item'>
                                        <div className='card-icon'>
                                            <SvgIcon component={icon} inheritViewBox />
                                        </div>
                                        <div className='card-label'>
                                            {<card.label />}
                                        </div>
                                        <div className='card-btn'>
                                            {button.color == 'light' ?
                                                <LightButton size="small" systemUI {...button} />
                                                :
                                                <Button size="small" systemUI {...button} />
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        )
                    })}
                </div>
            </div>
        </ManagerDashboardStyles>
    )
}

export default DashboardPage